import React from 'react'
import { StyleSheet, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { StatusBar } from 'expo-status-bar'
import { DS } from '@/design-system'
import { translate } from '../../i18n'
import { SettingsHeader } from './SettingsHeader'

type SettingsScreenLayoutProps = {
  title?: string
  onBack: () => void
  children: React.ReactNode
}

export function SettingsScreenLayout({ title, onBack, children }: SettingsScreenLayoutProps) {
  return (
    <SafeAreaView style={styles.container}>
      <StatusBar style="dark" />
      <SettingsHeader title={title} onBack={onBack} />
      {children}
    </SafeAreaView>
  )
}

export function SettingsCenteredMessage({ message }: { message: string }) {
  return (
    <View style={styles.centered}>
      <DS.Text variant="Body Large/Regular" style={{ color: DS.palette['Brand/Dark Grey'] }}>
        {message}
      </DS.Text>
    </View>
  )
}

export function SettingsLoadingView() {
  return (
    <View style={styles.centered}>
      <DS.Text variant="Body Large/Regular">{translate('common.loading')}</DS.Text>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: DS.palette['Brand/Cream']
  },
  centered: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  }
})
